import { ReactNode } from 'react';

import IPUnitProviderContext from 'features/systems/ip-unit/providers/contexts/ip-unit-provider-context';
import useIPUnitProviderState from 'features/systems/ip-unit/providers/states/ip-unit-provider-state';

type Props = {
  children: ReactNode;
};

const IPUnitProvider = ({ children }: Props): React.JSX.Element => (
  <IPUnitProviderContext.Provider value={useIPUnitProviderState()}>{children}</IPUnitProviderContext.Provider>
);

export default IPUnitProvider;
